import { Component, input } from '@angular/core';

export type ToggleOptionSize = 'small' | 'base' | 'large';

@Component({
  selector: 'bspk-toggle-option',
  imports: [],
  templateUrl: './toggle-option.component.html',
  styleUrl: './toggle-option.component.scss',
})
export class BspkToggleOption {
  label = input.required<string>();
  description = input<string>();
  size = input<ToggleOptionSize>('base');
}
